import { useTranslation } from "react-i18next";

import { Button } from "@/components/Interface/Button/Button";
import { FCC } from "@/types";

import { WelcomeCard } from "./WelcomeCard";

interface Props {
  onBack: () => void;
}

export const MagicLinkEmailSent: FCC<Props> = ({ onBack }) => {
  const { t } = useTranslation();

  return (
    <WelcomeCard>
      <div
        data-testid="magic-link-email-sent"
        className="flex w-full flex-col items-center gap-6"
      >
        <p className="text-body-base text-foreground-primary">
          {t("translation:newWelcome.magicLink.sent.message")}
        </p>

        <Button
          dataTestid="magic-link-email-sent-back"
          variant="primary"
          type="button"
          onClick={onBack}
        >
          {t("Common.label.backToLogin")}
        </Button>
      </div>
    </WelcomeCard>
  );
};
